import { render, staticRenderFns } from "./dataModelDetail.vue?vue&type=template&id=4727d1fa"
import script from "./dataModelDetail.vue?vue&type=script&lang=js"
export * from "./dataModelDetail.vue?vue&type=script&lang=js"
import style0 from "./dataModelDetail.vue?vue&type=style&index=0&id=4727d1fa&prod&lang=scss&scpoed=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports